import { ColumnConfig, PrincipalUserColumnKey } from '../model';

export const principalUserConfig: Record<PrincipalUserColumnKey, ColumnConfig> =
  {
    user: {
      name: 'Principal',
    },
    mobile: {
      name: 'Mobile Number',
    },
    email: {
      name: 'Email ID',
    },
    gst: {
      name: 'GST',
    },
    accountStatus: {
      name: 'Account Status',
    },
    action: {
      name: 'Action',
      field: 'component',
      alignment: 'flex-end',
    },
  };
